import {EnvironmentModel} from 'app/original-models/environment.model';

export const environment: EnvironmentModel = {
    production: true,
    isMaintenance: false,
    LICENSE_KEY: '92e3fc30-11fb-4e4b-b0aa-043990ebecac',
    apiUrl: 'https://uat.commitly.com/api',
    wssUrl: 'wss://uat.commitly.com/ws',
    versionFile: 'https://uat.commitly.com/version.txt',
    googleCaptchaKey: '6LcnT_UrAAAAAHZy-eKW8iTzpFD1zAknfDZcijSr',
    logLevel: 2,
    envName: 'uat',
    intercom: {
        appId: 'lf8q4lib',
        salt: '3UTLV5gU-8BynZuaofq1Zc9NgR6x_1EjvoXfg1lq'
    },
    getstream: {
        appToken: 'dtacgnyjzrr2',
        appID: '1347434'
    },
    gaEnabled: false,
    promoterEnabled: false,
    botUrl: 'https://dev.commitly.com/bot/slack/',
    refreshOnRecalculatedEvent: true,
    celloProductId: null,
    flatfile: {
        publishableKey: 'pk_7468896a16d6433ea7cc179185a6e7dd',
    },
    monite: {
        enabled: true,
        onlyForUsers: null,
        moniteApiUrl: 'https://uat.commitly.com/bills/v1',
        moniteJs: 'https://cdn.sandbox.monite.com/monite-app.js',
        moniteEmailDomain: '@mail.sandbox.commitly.com',
        billsAddonsApplyTrial: true,
        paymentsProvider: 'banksApi'
    },
    banking: {
        enabled: true,
        onlyForUsers: null,
        url: 'https://banking.sandbox.swan.io/projects/14e3cfd3-c1e3-45ae-a449-c8cd86dfdbf6/'
    },
    pivotFiscalCalculation: true,
    banksApi: {
        banksApi: {
            enabled: true,
            onlyForUsers: null
        },
        ebics: {
            enabled: false,
            onlyForUsers: null
        }
    },
    shopify: {
        enabled: true,
        onlyForUsers: ['yuriy.netskyi@sprinterra.com',
            'olha.hopaitsa@sprinterra.com',
            'volodymyr.startsev+0607@sprinterra.com',
            'volodymyr.startsev+020725@sprinterra.com'
        ]
    },
    cashBurnCharts: {
        enabled: true,
        onlyForUsers: null
    },
    datevExport: {
        enabled: true,
        onlyForUsers: null
    },
    goCardlessAllBanks: {
        enabled: true,
        onlyForUsers: ['yuriy.netskyi*',
            'alena.savenok+uat@sprinterra.com',
            'volodymyr.startsev*',
            'vitaliy.cherediy*'
        ]
    }
};
